/* global __SHIM_NODE_ENV__ */
/**
 * Browser `process` stub for webpack ProvidePlugin. Some dependencies read `process` at
 * runtime (not only `process.env.X`, which DefinePlugin inlines). Without this, lazy chunks
 * can throw `process is not defined` and break `__webpack_require__`.
 * `__SHIM_NODE_ENV__` is injected next to `process.env` in webpack DefinePlugin (avoid
 * circular `process` while this module is loading).
 */
module.exports = {
  browser: true,
  env: {
    NODE_ENV: __SHIM_NODE_ENV__,
  },
}
